import { render, staticRenderFns } from "./ModifierCreate.vue?vue&type=template&id=09d25e31&"
import script from "./ModifierCreate.vue?vue&type=script&lang=js&"
export * from "./ModifierCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports